import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import app from "../assets/portfolio/app.svg";

function AppComponent() {
  return (
    <div className="web">
      <div className="content-web-box shadow-sm">
        <Container>
          <Row className="content-web">
            <Col xs={12} md={6}>
              <img src={app} alt="..." className="img-fluid" />
            </Col>
            <Col xs={12} md={6}>
              <h4>
                Mobile App We've{" "}
                <span style={{ fontSize: "40px", color: "#22a178" }}>
                  Developed
                </span>
              </h4>
              <p>
                Developing an App is not an easy task. It requires skill to
                manage data in a mobile app. Here is some example our apps.
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default AppComponent;
